import script from "./BetBooster.vue?vue&type=script&setup=true&lang=js"
export * from "./BetBooster.vue?vue&type=script&setup=true&lang=js"

import "./BetBooster.vue?vue&type=style&index=0&id=652ec00b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-652ec00b"]])

export default __exports__